import { ChangeEvent } from "react";
import MpNumberTextField from "src/components/MpTextFieldNumberOnly";
import { useTranslation } from "src/hooks";
import { useBatchApproveAllowanceFormContext } from "../../../contexts";

function MaxNumberOfAddressesNumberTextField({
  value,
  onChange,
}: {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}) {
  const { tc } = useTranslation("common");
  const { translate: t } = useBatchApproveAllowanceFormContext();
  const label = t("max_number_of_addresses");

  return (
    <>
      <div>{label}</div>
      <MpNumberTextField
        value={value}
        label={tc("phInputField", { fieldName: label })}
        onChange={onChange}
      />
    </>
  );
}

export default MaxNumberOfAddressesNumberTextField;
